module.exports = __webpack_public_path__ + "static/doordash-red-719305885498e707432da942df24980a.png";